import { Action } from '@ngrx/store';

export enum ActionType {
    SelectBedRoom = '[Bed] select.bed.room',
    incrementStockCombine = '[PriceMatch] increment.stock.combine',
}

export class SelectBedRoom implements Action {
    type: string = ActionType.SelectBedRoom;

    constructor(public payload: { bedSelected: any, idRoom: number }) { }
}

export class incrementStockCombine implements Action {
    type: string = ActionType.incrementStockCombine;

    constructor(public payload: { combineIncremented: any, indexSearch: string }) { }
}